var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 33.6667C7.79565 33.6667 0.333984 26.205 0.333984 17C0.333984 7.795 7.79565 0.333332 17.0007 0.333332C26.2057 0.333332 33.6673 7.795 33.6673 17C33.6673 26.205 26.2057 33.6667 17.0007 33.6667ZM17.0007 14.6433L12.2873 9.92833L9.92898 12.2867L14.644 17L9.92898 21.7133L12.2873 24.0717L17.0007 19.3567L21.714 24.0717L24.0723 21.7133L19.3573 17L24.0723 12.2867L21.714 9.92833L17.0007 14.6433Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.9d65f0ca8f2d7b1fa860be3144f55552.svg";
export { ForwardRef as ReactComponent };